// 体质特征数据已随中医体质辨识同源，数据清洗由后端 module 列表带出，前端无需额外处理。
export default function transformFeature(/* state */) {
    return;
}
